var VueController ={
    componentStact:[],
    push:function(el,key){
        this.componentStact.push({ve:el,key:key});
        console.log("---after push---");
        console.log(this);
    },

    push:function(el){
        this.componentStact.push({ve:el,key:el.$options.name});
        console.log("---after push---");
        console.log(this);
    },

    pop:function(){
        this.componentStact.pop();
    },

    removeComponent:function(key){
        for(let i=0;i<this.componentStact.length;i++){
            let ob = this.componentStact[i];
            if(ob.key == key){
                this.componentStact.splice(i,1);
                break;
            }
        }

    },

    removeComponentByEl:function(el){
        for(let i=0;i<this.componentStact.length;i++){
            let ob = this.componentStact[i];
            if(ob.ve == el){
                this.componentStact.splice(i,1);
                break;
            }
        }
        console.log("---after remove---");
        console.log(this);
    },

    getComponentByComponentName:function(key){
        for(let i=0;i<this.componentStact.length;i++){
            let ob = this.componentStact[i];
            if(ob.key == key){
                return ob.ve;
            }
        }
        return null;
    }
};

export default VueController;